// libraries, constants, and class definitions

import * as createjs from "createjs-module";
import * as symConst from 'src/app/shared/constant/canvasSymTypes'; 
import {DISPLAY_TYPE_GRID, DISPLAY_TYPE_LINE, DISPLAY_TYPE_TEXT, SIZE,  START_XPOS, START_YPOS,
         SIZE,  CanvasInput} from 'src/app/shared/constant/drawConstants';
import { STATE_NORMAL, STATE_OPEN_FILE, STATE_INIT,STATE_IN_IPAD_ABC, 
    MLineType, SymbolSimple, SymbolTree,SymbolBranching,MBranchType,
    OverlayType,OVERLAY_TYPE_LINE,NUM_BASE_WIDTH,
    OVERLAY_TYPE_DIVIDE,STATE_CARRY_SYM, FRACTION_LINE_TYPE, ROOT_LINE_TYPE,FractionRootLine,
    STATE_WAIT_ADVANCE,STATE_WAIT_COMPLETE,NUM_BASE_WIDTH, TAB_UNIT_WIDTH, STATE_ROOT_FIRST} from 'src/assets/js/cv-classes.js';

// functions and varibles
import { drawProbShapes, makeProbSelected,
  drawCursor, drawNewLineSym,drawUpdatedOverlay,drawCrossOff } from 'src/assets/js/cv-graphics-mouse.js';
import { getSymFont,findProbEndX, findProbEndY,findNextPIndex,calcTabPos,
        removeChildFromStage,tallyLineSymWidths,resetMoveTreeProbHeight,
       tallyLineNobScale,resetTreeProbHeight,resetTreeXYPosAndCursor, doStageUpdate,
       adjustSymSpacingFromKeyboard,
       checkForTallParen} from 'src/assets/js/cv-helpers.js';
import {startMProb, drawOneSymText,drawOneTreeSym,drawCarryText,deleteProb} from 'src/assets/js/cv-layout-shared.js';
import {db,stage,draw,cvControl, clearProbState} from 'src/assets/js/draw.js';

export function resizeProbGridChange() {

 
  let oldGridW = db.curProb.gridW;
  let oldFontSize = db.curProb.fontSize;
  //db.initSize(newFontSize);
  let scale = db.gridWidth/oldGridW;
  db.curProb.probScale = scale;
  db.curContainer.scaleX = db.curContainer.scaleY = scale;
  doStageUpdate();
}


/***
 * function newGridSym is called from draw within canvas draw to draw the current keyID
 * symbol into the current x,y position.  It is the highest level routine of the grid management system,
 * and has a lot of complexity in details due to having to deal with subtle differences of how sIndex will
 * show up and be used, depending on whether writing at the end of a grid line, over an existing symbol, or
 * over a null character (entered for space filling)
 */

export function newTreeSym(keyID, groupCode, typeCode,textWidth) {
  
  //console.log(db.curBranch.isBranch, db.curBranch);
 
  // first time any symbol is drawn to the canvas, set the state to active/normal
  if (db.state == STATE_INIT) {
    db.state = STATE_NORMAL; // this may need setting extra places
  }
  
  // check if current symbol is a main line space created by a right arrow move, and if so, delete symbol to create overwrite of space
  if (!db.curBranch.isBranch && db.curBranch.sym.length > 0 && db.curBranch.sIndex+1 <= db.curBranch.sym.length-1 &&
    db.curBranch.sym[db.curBranch.sIndex+1].str == symConst.KEY_ID_SPACE && 
    db.curBranch.sym[db.curBranch.sIndex+1].type == symConst.CV_NUM_TYPE)  {
      cvControl(symConst.CV_CNTL_DELETE);
    }

  // if have tabEquals set in userPrefs and entered equal, then insert a tabequal sign first
  if (typeCode == symConst.CV_EQUALS_INQ_TYPE  && !db.curBranch.isBranch &&
    db.userPrefs.alignEqualSign && db.curProb.tabEqualPos != 0) {
      // only do the auto alignment if not past the equals position though
      let findCurPos = tallyLineSymWidths(db.curBranch,db.curBranch.sIndex);
      if (findCurPos < db.curProb.tabEqualPos) {
        draw(symConst.KEY_ID_TAB_EQUAL,symConst.CV_SIMPLE_GRP ,symConst.CV_SPECIAL_TYPE );
      }
  }
  
  // figure out the right font for this symbol
  let newSym;
  let cursorScale = 1;
  let haveTab= false;
  if (keyID == symConst.KEY_ID_LOG_A) {
    groupCode = symConst.CV_BRANCHING_GRP;
  }
  if (keyID == symConst.KEY_ID_DIVISION) {
    db.curProb.hasDivide = true;
  }

  // treat the prior exponent as a subscript of the prior symbol
  if (keyID == symConst.KEY_ID_EXPONENT_2) {
    if (db.curBranch.sIndex == -1) {
      return;
    }
    else {
      db.curBranch.sIndex--;
      //resetTreeXYPosAndCursor();
      keyID = symConst.KEY_ID_EXPONENT;
    }
  }

  // tabs and tab equals are only processed on main line, so just return if get on in a branch
  if (keyID == symConst.KEY_ID_TAB || keyID == symConst.KEY_ID_TAB_EQUAL) {
    haveTab = true;
    if (db.curBranch.branchID != 0) {
      return;
    }
  }

  if (keyID == symConst.KEY_ID_SQRT || keyID == symConst.KEY_ID_ROOT && !db.curBranch.isBranch) {
    db.curBranch.bHeightTop += .3*db.curProb.gridH;
  }

  if (typeCode == symConst.CV_EQUALS_INQ_TYPE) {

    // if there hasn't been an tabequal set, or current equal is past it, then set tabEqualPos to current
    db.curProb.tabEqualPos = tallyLineSymWidths(db.curBranch,db.curBranch.sIndex);
    
  }

  let drawUpdate = (db.STATE != STATE_OPEN_FILE) || db.curLine.sIndex >= db.curProb.widthFromFile-1 || 
                    db.curProb.widthFromFile == 0;
  
 
    if (groupCode == symConst.CV_BRANCHING_GRP) {
      newSym = new SymbolBranching(keyID, typeCode,groupCode)
      //console.log(groupCode, newSym);
    }
    else {
      newSym = new SymbolTree(keyID, typeCode,groupCode); // change this to support different symbol types
    }

    // determine if first symbol in main line, so if it's an operator it's width gets set differently to align arithmetic better
    let firstSymFlag = (!db.curBranch.isBranch && db.curBranch.sIndex == -1);

    newSym.setSymTraits(keyID,typeCode,groupCode,firstSymFlag);

    //console.log(keyID,typeCode,groupCode,db.curBranch.sym[db.curBranch.sIndex]);
    //if (db.mathLevel == 4) {
      //adjustSymSpacingFromKeyboard(newSym);
    //}

    if (!db.curBranch.isBranch) {
      checkForTallParen(newSym);
    }
    
    let keyStr = (newSym.altStr) ? newSym.alt : keyID;
 
    let symFont = getSymFont(keyStr, typeCode,false,newSym.tall);  // deal with size to
  
    
    // if this is really ab abc text, then set the width to be the text width to treat this like a regular symbol
    if (typeCode == symConst.CV_TEXT_TO_LINE) {
      newSym.width = (textWidth) ? textWidth : 1;
    }
    

    if (haveTab) {
      let temp1 = tallyLineSymWidths(db.curBranch,db.curBranch.sIndex);
      if (keyID == symConst.KEY_ID_TAB_EQUAL && db.curProb.tabEqualPos >= temp1 && db.curProb.tabEqualPos != 0) {
        newSym.tabWidth = db.curProb.tabEqualPos-temp1;
      }
      else {
        newSym.tabWidth = calcTabPos(temp1);
      }
      db.xpos += newSym.tabWidth*db.curProb.gridW;
    }
    
    // need to have branch symbol branches created before doing the symbol add, 
    // so al the spacing gets fixed correctly
    if (groupCode == symConst.CV_BRANCHING_GRP && newSym.branchCount > 0) {

      // set flag for special sym width calcs if sum/limit
      if (typeCode == symConst.CV_SUM_LIMIT_TYPE) {
        db.curProb.inSumLimit = true;
      }
      for (let i = 0; i < newSym.branchCount; i++) {
        createBranch(keyID, newSym, i);
      }
    }
    
    // addSym also adds to the current branch lineWidth
    let shiftSyms = db.curBranch.addSym(newSym,db.curLine.lineWidth,db.curBranch.sIndex);
 
    
     // set up a createjs object to draw this symbol
     // unless this is a branching symbol of a type that doesn't display an initial symbol
    if (groupCode != symConst.CV_BRANCHING_GRP ||
        typeCode == symConst.CV_SUM_LIMIT_TYPE ||
        //typeCode == symConst.CV_DIV_SQRT_TYPE ||
        keyID == symConst.KEY_ID_E_EXPONENT ||
        keyID == symConst.KEY_ID_LOG_A)  {

      newSym.displayText = drawOneTreeSym(keyID, symFont, newSym, typeCode, shiftSyms);
   
      
   
      db.xpos += db.curProb.gridW * newSym.width; //  * db.curBranch.bScale;

    
    }
 

    if (groupCode == symConst.CV_BRANCHING_GRP && newSym.branchCount > 0) {
     

      if (db.isBranchAMode) {
     
         // set the state to allow auto advancing if in A (single-digit) mode
        switch (typeCode) {
          case symConst.CV_FRACTION_TYPE:
            db.probState = STATE_WAIT_ADVANCE;
            break;
          case symConst.CV_DIV_SQRT_TYPE:
            break;
          default:
            db.probState = STATE_WAIT_COMPLETE;
            break;
        }
      }
    

      if (keyID == symConst.KEY_ID_FRACTION || typeCode == symConst.CV_DIV_SQRT_TYPE) {
        startFractionRootLine(newSym);

      }
      // geometry over-line symbols (line segment, and later ray/line) register a growing
      // line above their branch, reusing the same branchSymList mechanism as fraction/sqrt
      if (typeCode == symConst.CV_GEO_OVER_TEXT) {
        startGeoOverline(newSym);
      }
      db.curBranch = newSym.branch[0];
      resetTreeXYPosAndCursor();
      //if (drawUpdate) {
      //    drawProbShapes(Math.max(db.curProb.width+1,2),db.curProb.line.length);
      //}
    }
   
    
    // check this, not sure -  not right deal with branches
    db.curProb.width = Math.max(db.curLine.lineWidth,db.curProb.width);
 
    if (shiftSyms) {
      for (let i = 0; i <= db.curLine.branchSymList.length-1; i++) { 
        drawFractionRootLine(db.curLine.branchSymList[i], 
                         db.curLine.branchSymList[i].parentBranch);
      }      
      resetLineTextPos(db.curBranch); 
      if (db.curBranch.parent != null && db.curBranch.parent.isBranch) {
        resetLineTextPos(db.curBranch.parent);
      }
     
    } 
    resetLineTextPos(db.curLine); 

    resetTreeXYPosAndCursor();
    // if shiftSyms then also tell drawProbShapes to redraw main line branch background to get correct length of that
    drawProbShapes(Math.max(db.curProb.width+1,2),db.curProb.line.length,shiftSyms);

    if (db.state != STATE_OPEN_FILE) {
      // check to see if in an A mode waiting state, and if got single digit then send complete and advance state.
        if (db.probState == STATE_WAIT_ADVANCE || db.probState == STATE_WAIT_COMPLETE) {
  
          if (groupCode == symConst.CV_SIMPLE_GRP || typeCode == symConst.CV_VAR_TYPE || typeCode == symConst.CV_VAR_SQR_TYPE) {
            db.probState = (db.probState == STATE_WAIT_COMPLETE) ? STATE_NORMAL : STATE_WAIT_COMPLETE; 
            cvControl(symConst.CV_CNTL_COMPLETE);
          }
          else if (groupCode != symConst.CV_BRANCHING_GRP) {
            db.probState = STATE_NORMAL; // cancel the A mode if they entered a complex symbol first
          }
        }
      }
      
    
}



function startFractionRootLine(newSym) {

  let lineType;
  if (newSym.str == symConst.KEY_ID_FRACTION) {
    lineType = FRACTION_LINE_TYPE;
  }
  else if (newSym.str == symConst.KEY_ID_ROOT) {
    lineType = ROOT_LINE_TYPE;
    
    db.probState = STATE_ROOT_FIRST;
  }
  else {
    lineType = ROOT_LINE_TYPE;
  }

  // create a FractionRootLine object to hold info, and add it to the fraction arrow in curline of curProb
  //newSym.FractionRootLine = new FractionRootLine(lineType,db.curBranch,newSym,
  //                                        tallyLineSymWidths(db.curBranch, db.curBranch.sIndex-1),
   //                                        newSym.width);
                                           
  //newSym.FractionRootLine.bScale = newSym.branch[0].bScale;
  newSym.startPos = tallyLineSymWidths(db.curBranch, db.curBranch.sIndex-1);
  newSym.growing = true;
  newSym.growType = lineType;
  newSym.parentBranch = db.curBranch;
  db.curLine.branchSymList.push(newSym);
  drawFractionRootLine(newSym,db.curBranch);

  db.curLine.inFraction = true;


}
/**
 * sym.displayText is used to hold fraction line or division symbol
 */

export function drawFractionRootLine(sym,branch,color) {

  let lineLength, strokeSize;
  let saveX = 0;

  if (sym.displayText != null) {
    saveX = sym.displayText.x;
    branch.container.removeChild(sym.displayText);
  }
  // change color to be taken from userPrefs
  //color = (color == null) ? "black" : color;  
  color = db.userPrefs.cvMainColor;
  sym.displayText = new createjs.Shape(); 
  sym.displayText.x = (saveX == 0) ? sym.startPos*db.curProb.gridW : saveX;  
  sym.displayText.y = 0; 
  if (sym.str == symConst.KEY_ID_SQRT || sym.str == symConst.KEY_ID_ROOT) {
      drawSqrt(branch,sym,color);
  }
  else if (sym.str == symConst.KEY_ID_GEO_LINE_SEG ||
           sym.str == symConst.KEY_ID_GEO_RAY ||
           sym.str == symConst.KEY_ID_GEO_LINE ||
           sym.str == symConst.KEY_ID_GEO_ARC) {
      drawGeoOverline(branch,sym,color);
  }
  else { // fraction or division

      sym.displayText.y = -0.07*db.curProb.gridW;  // adjust fraction up a touch, just cause that's how the numbers seem to lay out
      //sym.width  = Math.max(sym.branch[0].lineWidth,sym.branch[1].lineWidth,NUM_BASE_WIDTH*db.curBranch.bScale);
      strokeSize = 2*db.curBranch.bScale;
  
    lineLength = sym.width*db.curProb.gridW;   //sym.width*db.curBranch.bScale*db.curProb.gridW; // sym.branch[0].bScale
 

      sym.displayText.graphics.beginStroke(color).setStrokeStyle(2);
      if (sym.str == symConst.KEY_ID_FRACTION) {
        sym.displayText.graphics.moveTo(0,db.curProb.halfGH*branch.bScale).lineTo(lineLength,db.curProb.halfGH*branch.bScale);
      }
      else { //division
        //let startX = db.curProb.gridW*db.curBranch.bScale*.2;
        //sym.displayText.x += startX;
        //sym.width = Math.min( startX,sym.width);
        sym.displayText.graphics.moveTo(0,0);
        //sym.displayText.graphics.curveTo(20,20,5,50);
        //sym.displayText.graphics.arc(5,10,20,50,30); 
        sym.displayText.graphics.moveTo(0,db.curProb.gridH*branch.bScale*.9).lineTo(0,db.curProb.gridH*branch.bScale*.1);
        //sym.displayText.graphics.lineTo(lineLength + sym.bOffsetX[0]*db.curProb.gridW,db.curProb.gridH*branch.bScale*.1); 
        sym.displayText.graphics.lineTo(lineLength ,db.curProb.gridH*branch.bScale*.1); 
      }
  }
  
  branch.container.addChild(sym.displayText);
  doStageUpdate();
}


/* draw the sqrt symbol 
*/
function drawSqrt(branch,sym,color) {

  
  sym.displayText.y = -0.07*db.curProb.gridW;  // adjust fraction up a touch, just cause that's how the numbers seem to lay out

  //sym.width = Math.max(sym.branch[0].lineWidth,sym.width);
  //let strokeSize = 2*db.curBranch.bScale;
  //branch.lineWidth = tallyLineNobScale(branch, branch.sIndex);
  
  //if (sym.width == 0) {
  //  lineLength = sym.width*db.curProb.gridW*sym.branch[0].bScale + db.curProb.gridW*sym.branch[0].bScale; // add scale
  let  lineLength = Math.max(sym.width*db.curProb.gridW, db.curProb.gridW*db.curBranch.bScale*1.8); // sym.branch[0].bScale;
  //let sqrtlength = lineLength = db.curProb.grid*sym.branch[0].bScale;

  sym.displayText.graphics.beginStroke(color).setStrokeStyle(2);

  if (branch.branchID == 0) {  // on main branch
    sym.displayText.y = -.1*db.curProb.gridH*branch.bScale;  // move sqrt symbol up a little
  }
  else {
    if (branch.container.y > 0) { // in branch that is in on botttom half of the parent symbol
      sym.displayText.y = .2*db.curProb.gridH*branch.bScale;  // move sqrt symbol up a little
      }
    else {
      sym.displayText.y = .1*db.curProb.gridH*branch.bScale;  // move sqrt symbol up a little
    }
  }
  // Apply the scale of the symbol branch to this sqrt symbol drawn (which is in parent branch) so sqrt sym matches branch size
  let sGridW = db.curProb.gridW*sym.branch[0].bScale*.9;
  let sGridH = db.curProb.gridH*sym.branch[0].bScale*.9;
  sym.displayText.graphics.moveTo(sGridW*.15,sGridH*.6).lineTo(sGridW*.3,sGridH*.5);
  sym.displayText.graphics.setStrokeStyle(3).moveTo(sGridW*.3,sGridH/2).lineTo(sGridW/1.5,sGridH*.9).setStrokeStyle(2);
  sym.displayText.graphics.setStrokeStyle(2).moveTo(sGridW/1.5,sGridH*.9).lineTo(sGridW,0)
  //sym.displayText.graphics.lineTo(db.curProb.gridW*db.curBranch.bScale+lineLength,0);
  sym.displayText.graphics.lineTo(lineLength,0);
}


/**
 * function startGeoOverline registers a geometry over-line symbol (line segment now,
 * ray/line later) so a horizontal line is drawn above its branch and grows as the user
 * types variables into the branch.  Modeled on startFractionRootLine, minus the
 * fraction/root-specific state (no probState change, no inFraction flag).
 * Must be called while db.curBranch is still the PARENT branch (before moving into branch[0]).
 */
function startGeoOverline(newSym) {
  newSym.startPos = tallyLineSymWidths(db.curBranch, db.curBranch.sIndex-1);
  newSym.growing = true;
  newSym.parentBranch = db.curBranch;
  db.curLine.branchSymList.push(newSym);   // so it redraws on every add/delete in this line
  drawFractionRootLine(newSym, db.curBranch);
}

/**
 * function drawGeoOverline draws the horizontal line above a geometry over-line symbol.
 * Its length matches the width of the variables in the branch (sym.branch[0].lineWidth),
 * with a one grid-unit minimum so an empty symbol still shows a short line.
 * Shape is chosen by sym.str: KEY_ID_GEO_ARC = a shallow curved cap (no arrowheads);
 * otherwise a straight over-line with arrowheads per str: KEY_ID_GEO_RAY = one arrow at the
 * far (right) end; KEY_ID_GEO_LINE = arrows at both ends; KEY_ID_GEO_LINE_SEG = none.
 * sym.displayText is the createjs.Shape already created/positioned in drawFractionRootLine.
 */
function drawGeoOverline(branch, sym, color) {
  const GEO_MIN_UNITS = 1;          // one grid-unit wide when empty
  const GEO_ARROW_UNITS = 0.15;     // arrowhead size in grid units (tunable)
  const GEO_ARC_DEPTH_UNITS = 0.4; // arc bow depth in grid units (tunable); curve peak is ~half this
  let contentUnits = (sym.branch[0] != null) ? sym.branch[0].lineWidth : 0;
  let lineUnits = Math.max(contentUnits, GEO_MIN_UNITS);
  let lineLength = lineUnits * db.curProb.gridW;

  // draw the line just above the tops of the letters; lineY is tunable for spacing
  let lineY = 0.08 * db.curProb.gridH * branch.bScale;
  sym.displayText.graphics.beginStroke(color).setStrokeStyle(2);

  // arc: a shallow curved cap over the letters (no arrowheads). One quadratic Bézier from
  // the left end to the right end, control point pulled up at the midpoint to bow it.
  // The endpoints sit a touch lower than the straight over-line so they nearly meet the letters.
  if (sym.str == symConst.KEY_ID_GEO_ARC) {
    const GEO_ARC_DROP_UNITS = 0.05; // lower the arc's endpoints toward the letters (tunable)
    let arcY = lineY + GEO_ARC_DROP_UNITS * db.curProb.gridH * branch.bScale;
    let depth = GEO_ARC_DEPTH_UNITS * db.curProb.gridH * branch.bScale;
    sym.displayText.graphics.moveTo(0, arcY).quadraticCurveTo(lineLength / 2, arcY - depth, lineLength, arcY);
    return;
  }

  // straight over-line (segment / ray / line)
  sym.displayText.graphics.moveTo(0, lineY).lineTo(lineLength, lineY);

  // Arrowheads. a = arrow size; each head is two short barbs angling back from the tip.
  let a = GEO_ARROW_UNITS * db.curProb.gridW * branch.bScale;
  if (sym.str == symConst.KEY_ID_GEO_RAY || sym.str == symConst.KEY_ID_GEO_LINE) {
    // right end, pointing right (barbs open back toward the left)
    sym.displayText.graphics.moveTo(lineLength, lineY).lineTo(lineLength - a, lineY - a);
    sym.displayText.graphics.moveTo(lineLength, lineY).lineTo(lineLength - a, lineY + a);
  }
  if (sym.str == symConst.KEY_ID_GEO_LINE) {
    // left end, pointing left (barbs open back toward the right)
    sym.displayText.graphics.moveTo(0, lineY).lineTo(a, lineY - a);
    sym.displayText.graphics.moveTo(0, lineY).lineTo(a, lineY + a);
  }
}


export function doAdvance() {

  if (db.curBranch != null && db.curBranch.isBranch) {
    let parentLine = db.curBranch.parent;
    let bIndex = db.curBranch.parentIndex;
    let firstWidth = db.curBranch.lineWidth;
    if (db.probState == STATE_ROOT_FIRST) {
      db.probState = STATE_NORMAL;
    }
   
    // check if the current branching symbol has multiple branches, 
    //if so then move to the other branch
    if (parentLine.sym[bIndex].branch.length>1) {
      
      let newBranchIndex = (db.curBranch.branchIndex == 0) ? 1 : 0; 
      db.curBranch.needComplete = false; // set prior branch to complete, but branch switched to as not complete
     
      db.curBranch = parentLine.sym[bIndex].branch[newBranchIndex];
      db.curBranch.needComplete = true;
      resetTreeXYPosAndCursor();

      if (parentLine.sym[bIndex].str == symConst.KEY_ID_SUMMATION_2  && newBranchIndex == 1) { 
      
        db.curBranch.container.x += firstWidth*db.curProb.gridW;
        draw(symConst.KEY_ID_LIMIT_ARROW,symConst.CV_SIMPLE_GRP, symConst.CV_MISC_TYPE);
      }
      
    }
  }
}

export function doControlComplete() {

  if (db.curBranch != null && db.curBranch.isBranch) {

    let parent = db.curBranch.parent;
    let sIndex = db.curBranch.parentIndex; 
    db.curBranch.needComplete = false;

    if (parent.sym[sIndex].branchCount == 2  && db.curBranch.branchIndex == 0) {
      doAdvance();
    }
    else {

      if (parent.sym[sIndex].str == symConst.KEY_ID_FRACTION || parent.sym[sIndex].type == symConst.CV_DIV_SQRT_TYPE) {
        parent.sym[sIndex].growing = false;
      }
      else {
     
        //parent.sym[sIndex].width += db.curBranch.lineWidth * db.curBranch.bScale;
        //parent.lineWidth += db.curBranch.lineWidth * db.curBranch.bScale;
      }

      db.curBranch = parent;
      //if (db.curProb.inSumLimit) {
      //  db.curBranch.sym[db.curBranch.sIndex].width = Math.max()

     // }
      //drawProbShapes(Math.max(db.curProb.width+1,2),db.curProb.line.length,true);
 
      resetTreeXYPosAndCursor();
      
      
    }
  }

}


function createBranch(keyID, newSym, bIndex) {

  let resetLineYs = false;
  let nestY = 0;
  let newBranch = new MBranchType(0,0, // newSym.bOffsetX[bIndex], newSym.bOffsetY[bIndex],
                                           newSym.bScale);
  newBranch.parent = db.curBranch;
  newBranch.parentIndex = db.curBranch.sIndex; // this could change on insert/delete

  
  // The branchID starts at 0 for main branch and counts up for each branch
  newBranch.branchID = db.curProb.line[db.curProb.lIndex].nextBranchID++;
  // the branch Index identifies which branch within a symbol this is, either 0 or 1
  newBranch.branchIndex = bIndex;
  newBranch.isBranch = true;  
  newBranch.needComplete = true;
  newBranch.myLine = db.curLine;
  // save offset so in symbol add can adjust parent branch width for this
  newBranch.offsetX = newSym.bOffsetX[bIndex];
  newBranch.container = new createjs.Container;
  // if fraction not from the main one, the make smaller)
  //if (newSym.str == symConst.KEY_ID_FRACTION && db.curBranch.width != 0 && db.curBranch.branchIndex != 0) {
  //  newBranch.bScale = .7 * db.curBranch.bScale;
  //}
  //else {
   newBranch.bScale = newSym.bScale*db.curBranch.bScale;   // scale is the symbol scale times the parent's scale
  //}
  // root is the only symbol where the 2 branches are different sizes, so since symbol can't define
  // that, adjust for it here
  //if (newSym.str == symConst.KEY_ID_ROOT && bIndex == 0) {
  //  newBranch.bScale = newBranch.bScale * .8;
  //}
  newBranch.lineHeight = newSym.bScale;  // in gridUnits, set branch height to scaled size based on branching symbol type
  db.curLine.container.addChild(newBranch.container);
  
  let tempX = tallyLineSymWidths(db.curBranch, db.curBranch.sIndex)*db.curProb.gridW + db.curBranch.container.x;
  //newBranch.container.x = db.xpos - db.curProb.halfGW - db.curProb.container.x;  
  newBranch.container.x = tempX;
  let xtemp =  (newSym.bOffsetX[bIndex] * db.curProb.gridW * db.curBranch.bScale);
  newBranch.container.x += xtemp;
  
  if (db.curBranch.isBranch) {
    nestY = db.curBranch.container.y;
    //console.log(db.curLine.container.y, db.curBranch.container.y);
  }
  else {
    nestY = db.curBranch.container.y-db.curLine.container.y
  }
  
  //newBranch.container.y = db.ypos - db.curProb.halfGH- db.curProb.container.y - db.curLine.container.y + nestY; 
  newBranch.container.y = db.curBranch.container.y-nestY;
  newBranch.container.y = nestY;
  let ytemp = (newSym.bOffsetY[bIndex] * db.curProb.gridH*db.curBranch.bScale); 
            
  newBranch.container.y += ytemp; 

  if (newSym.str == symConst.KEY_ID_SQRT) {
    newBranch.container.x += db.curProb.gridW*newBranch.bScale;
  }
 
  
  newSym.branch[bIndex] = newBranch;
 

  // track changes to this line height, update height to most vertical (negative) position
  let branchBot = newBranch.container.y + db.curProb.gridH*db.curBranch.bScale;
  
  newBranch.bHeightTop = (newBranch.container.y < 0 ) ? -newBranch.container.y : 0;
  newBranch.bHeightBot = (branchBot > 0) ? branchBot : 0;

  // Geometry ray/line/arc draw an arrowhead or curved cap that rises ABOVE the letters (on
  // sym.displayText), which newBranch.container.y doesn't account for.  Reserve that extra top
  // height so a line above doesn't collide.  Grow-only (Math.max), like the way sqrt/exponent
  // reserve height - this canvas does not shrink line height when a tall symbol is deleted.
  // (Plain line segment's over-line sits within the letter row, so it needs no reservation.)
  if (newSym.type == symConst.CV_GEO_OVER_TEXT && newSym.str != symConst.KEY_ID_GEO_LINE_SEG) {
    const GEO_OVERLINE_RESERVE_UNITS = 0.15; // extra top height in grid units (tunable)
    let geoReserve = GEO_OVERLINE_RESERVE_UNITS * db.curProb.gridH * db.curBranch.bScale;
    newBranch.bHeightTop = Math.max(newBranch.bHeightTop, geoReserve);
  }

  // if in first line, then check if top of problem height needs changing

  //console.log("start",newBranch.bHeightTop,newBranch.bHeightBot);

  if (newBranch.parent.bHeightTop < newBranch.bHeightTop || newBranch.parent.bHeightBot < newBranch.bHeightBot ||
    db.curLine.bHeightTop < newBranch.bHeightTop || db.curLine.bHeightBot < newBranch.bHeightBot) {
    resetLineYs = true;
  }
  
  //if (db.curLine.bHeightTop < newBranch.bHeightTop || db.curLine.bHeightBot < newBranch.bHeightBot) {
  //  resetLineYs = true;
  //}

  db.curLine.bHeightTop = Math.max(db.curLine.bHeightTop,newBranch.bHeightTop);
  //console.log(db.curLine.bHeightBot, newBranch.bHeightBot);
  //console.log(db.curLine.bHeightBot);
  db.curLine.bHeightBot = Math.max(db.curLine.bHeightBot, newBranch.bHeightBot);

  //console.log(db.curLine.bHeightBot);
  if (resetLineYs) {
    resetMoveTreeProbHeight();
    resetTreeXYPosAndCursor();
    drawProbShapes(db.curLine.lineWidth, db.curProb.heightAbove+db.curProb.heightBelow);
  }
  else {
    resetTreeProbHeight();
  }
}




/***
 * function resetLineTextPos goes through one line or branch and resets each
 * x position of each symbol container using the symbol widths.  This will move the line symbols right or
 * left after an insert or delete symbol in that line.   
 * Other lines branches in problem are adjusted by changing the line container instead
 * CHECK - what was function on noLineMove parameter in grid version?  this left out. 
 * CHECK - ABC not needing anything special
 */
export function resetLineTextPos(line) {
    //console.log(db.curLine,sIndex,end, line, db.curProb);
    let nextUnitPos = 0;
   
    for (let i = 0; i <= line.sym.length-1; i++) {

      //text.x = (findWidth * db.curProb.gridW) + // not db.curBranch.bScale in tally) + 
      //(db.curProb.gridW * db.curBranch.bScale * sym.symOffsetX);   

          
          if (line.sym[i].displayText != null) {  // branch symbols such as exponent will have no display text
           line.sym[i].displayText.x = nextUnitPos*db.curProb.gridW + 
                                      (db.curProb.gridW * line.sym[i].symOffsetX*line.bScale);
                      
           }
           else {
             //console.log("found null displayText",line.sym[i].str,line.sym[i], line.sym[i].displayText);
           }
     
          if (line.sym[i].crossOff != null) {
              line.sym[i].crossOff.x = nextUnitPos*db.curProb.gridW; // CHECK IF NEED TO ADD CROSS-OFF FACTOR
          }

          if (line.sym[i].tabWidth > 0) {
            nextUnitPos += line.sym[i].tabWidth;
        
          } 
          else {
            nextUnitPos += line.sym[i].width;
          }
    
        //console.log("Next unit pos", nextUnitPos);
    }
   
    doStageUpdate();
 

}






// insert a line into db structure, at the lIndex position in the mProb given
// set the cursor and x,y positions based on passed sIndex
export function insertSymLine(mProb,sIndex,lIndex) {
    let newLine = new MLineType();
    mProb.line.splice(lIndex,0,newLine);
    db.curLine = newLine;
    mProb.lIndex = lIndex;
    db.curLine.sIndex = sIndex;
    drawProbShapes(Math.max(mProb.width+1,2),mProb.line.length);
    drawCursor(db.xpos-db.curProb.halfGW, db.ypos-db.curProb.halfGH);
  }
  

/***
 * function newCrossOff determines if a new crossoff symbol should be followed by carry digits
 * and the associated db.state change, then
 * calls drawCrossOff to draw the symbol
 */
 export function newTreeCrossOff(keyID) {

  
  // check if need to set up for writting a carry symbol in the same grid
  if (keyID == symConst.KEY_ID_GRAY_CROSSOFF_2 || keyID == symConst.KEY_ID_BLUE_CROSSOFF_2 
      || keyID == symConst.KEY_ID_CROSSOFF_2 || keyID == symConst.KEY_ID_CROSSOFF_3) {
    db.curBranch.sym[db.curBranch.sIndex+1].crossOffAddComplete = true;
    db.probState = STATE_CARRY_SYM;
  }
  
  drawCrossOff(db.curBranch.sym[db.curBranch.sIndex+1],db.curBranch.sIndex+1,db.curProb.lIndex, keyID);

}

/***
 * function newCarry creates symbol objects for carry digits in the grid with a crossOff symbol,
 * and calls drawCarryText to draw it
 */

export function newTreeCarry(keyID) {
 
  let symFont = getSymFont(keyID, symConst.CV_NUM_TYPE,"true");
  drawCarryText(db.curBranch.sym[db.curBranch.sIndex+1], keyID, symFont, 'black'); 

}

/**
 * function deleteFromTree() is called from cvControl when a delete is received
 * 
 */
export function deleteFromTree(keyID) {
  
  //console.log(db.curProb,db.curLine);
  let tempIndex, deleteBranchSym;
  let probDeleted = false;
  let noneDeleted = false;
  let shiftSyms = false;
  
 //console.log(db.curProb.line.length, db.curLine.sym.length, (db.curBranch == db.curLine));
  // first check if it's an empty problem or last character in problem, 
  // in which case delete the problem
  //console.log("LINE length",db.curLine.sym.length,db.curLine);
  
  if ((db.curProb.line.length < 1) || 
    (db.curProb.line.length == 1 && db.curLine.sym.length < 1)) {  

    deleteProb();  // remove createjs objects for this problem
    probDeleted = true;
  }
  //next check if at the start of a line, if so then delete the line and not a symbol
  else if (db.curBranch == db.curLine && db.curLine.sym.length == 0) {

    db.curLine.container.removeAllEventListeners();
    db.curProb.container.removeChild(db.curLine.container);

    // adjust the lineIDs of any following lines down, for use in mouse watcher to keep the
    // prior event handlers, which points to this line, to be in synch. 
    for (let k = db.curProb.lIndex+1; k <= db.curProb.line.length-1 ; k++) {
      db.curProb.line[k].lineID--;
    }

    // move to the prior line if it wasn't the first line deleted
    if (db.curProb.lIndex > 0) {
      tempIndex  = db.curProb.lIndex-1;
      console.log("deleteLine checkheight change",tempIndex, db.curProb.heightBelow, db.curLine.bHeightTop); 
      db.curProb.heightBelow -= db.curLine.bHeightBot + db.curLine.bHeightTop;
    } 
    // otherwise move to the second line, which is the one after current one, and lIndex will stay the same
    else  { 
      tempIndex = db.curProb.lIndex;
      db.curProb.heightAbove -= db.curLine.bHeightTop;
      db.curProb.heightBelow -= db.curLine.bHeightBot;
    }
  
    db.curProb.line.splice(db.curProb.lIndex,1); 
    db.curLine = db.curProb.line[tempIndex];
    db.curProb.lIndex = tempIndex;
    db.curBranch = db.curLine;
    //console.log("delete line",db.curLine);
    // reset the line heights and container.y postiions after line delete
    resetMoveTreeProbHeight();

    // need to recalculate line heights
    // ?? should sIndex be set to start or end of line?  leave wherever it's at the moment

  }
  // if at the start of a branch which is not the main line, then delete that branch and
  // move to the main line.  this doesn't change the width of the line
  else if (db.curBranch.sym.length == 0) {
 
    db.curBranch.isDeleted = true;
    let otherIndex = (db.curBranch.branchIndex == 0) ? 1 : 0;
    let tempIndex = db.curBranch.parentIndex;  // this will move the branch symbol, do I want that?
    db.curLine.container.removeChild(db.curBranch.container);
    db.curBranch = db.curBranch.parent;
    db.curBranch.sIndex = tempIndex;
    if (db.curBranch.sIndex >= 0) {
      let branchSym = db.curBranch.sym[db.curBranch.sIndex];
      if (branchSym.branchCount > 1) {
        deleteBranchSym = (branchSym.branch[otherIndex].isDeleted); 
      }
      else {
        deleteBranchSym = true;
      }
    }
    
   // delete the branch symbol and it's branches
   if (deleteBranchSym) {
    // console.log("make call", db.curBranch, db.curBranch.sIndex, db.curBranch.sym[db.curBranch.sIndex]);
     shiftSyms = deleteFromOneLine(--db.curBranch.sIndex);
    
   }
   
    else {
      db.curBranch = db.curBranch.sym[db.curBranch.sIndex].branch[otherIndex];
      db.curBranch.sIndex = db.curBranch.sym.length-1;
    }

  }
 
  else { // finally found it is a regular symbol delete, so do that

    // determine action if backspace.  If prior symbol is branch, then do left arrow instead.   
    // no action if start of line
    if (keyID == symConst.CV_CNTL_BACKSPACE) {
  
      // start of branch
      if (db.curBranch.sIndex < 0 ) {
        noneDeleted = true;
      }
      // substitute left arrow if position from backspace would be that of a branching symbol
      else if (db.curBranch.sym[db.curBranch.sIndex].groupCode == symConst.CV_BRANCHING_GRP) {
        cvControl(symConst.CV_CNTL_ARROWLEFT);
        noneDeleted = true;
      }
      else {
        db.curBranch.sIndex--;
        shiftSyms = deleteFromOneLine(db.curBranch.sIndex);
      }
    }
    // otherwise keyID was delete, so process normally
    else {
      shiftSyms = deleteFromOneLine(db.curBranch.sIndex);
    }

    // If the last variable in a geometry over-line symbol was just deleted, its branch is now
    // empty.  Remove the whole symbol (over-line included) rather than leaving an empty over-line
    // active, so the next typed symbols land outside it on the main line.
    if (!noneDeleted && db.curBranch.isBranch && db.curBranch.sym.length == 0 &&
        db.curBranch.parent.sym[db.curBranch.parentIndex] != null &&
        db.curBranch.parent.sym[db.curBranch.parentIndex].type == symConst.CV_GEO_OVER_TEXT) {
      removeEmptyGeoOverline();
      shiftSyms = true;
    }

    if (!noneDeleted) {
    // reset the problem width by checking all the line lengths
      let resetProbWidth = 0;
      for (let i = 0; i <= db.curProb.line.length-1 ; i++) {
        if (db.curProb.line[i].lineWidth > resetProbWidth) {
          resetProbWidth = db.curProb.line[i].lineWidth;
        }
      }
      db.curProb.width = resetProbWidth;
      
      // fix up any of the fractionlines and other lines
      for (let k = 0; k <= db.curLine.branchSymList.length-1; k++) { 
        drawFractionRootLine(db.curLine.branchSymList[k], 
                        db.curLine.branchSymList[k].parentBranch);
      }
    }

  }
  // reset the x,y position and cursor
  if (!probDeleted && !noneDeleted) {
    if (shiftSyms) { 
      resetLineTextPos(db.curBranch);
      if (db.curBranch.parent != null && db.curBranch.parent.isBranch) {
        resetLineTextPos(db.curBranch.parent);
      }
    }
    resetLineTextPos(db.curLine); 
    resetTreeXYPosAndCursor()
    //shiftSyms indicate whether drawProbShapes needs to redraw the background box of the branch and branch parent
    drawProbShapes(db.curBranch.lineWidth, db.curProb.heightAbove+db.curProb.heightBelow,shiftSyms);
  }

  doStageUpdate();
 //console.log(db.curBranch,db.curBranch.sym.length);
}

/**
 * function removeEmptyGeoOverline deletes a geometry over-line symbol whose branch has just
 * become empty (the user deleted its last variable).  It mirrors the empty-branch handling in
 * deleteFromTree for single-branch symbols: remove the empty branch container, move to the
 * parent line, and delete the branching symbol itself - deleteFromOneLine then removes the
 * over-line shape and the branchSymList entry.  On entry db.curBranch is the empty geo branch.
 */
function removeEmptyGeoOverline() {
  db.curBranch.isDeleted = true;
  let geoIndex = db.curBranch.parentIndex;
  db.curLine.container.removeChild(db.curBranch.container);
  db.curBranch = db.curBranch.parent;
  db.curBranch.sIndex = geoIndex;
  deleteFromOneLine(--db.curBranch.sIndex);   // single-branch symbol -> delete it from the line
}

 // function handleDeleteFromGrid is called after the user clicks a delete key to delete one symbol
 export function deleteFromOneLine(sIndexToDelete) {
   

    let textToDelete;
    let probDel = false;
    let count = -1;
   
    let symIndex;
      
      if (sIndexToDelete == db.curBranch.sym.length-1) {
      
          symIndex = sIndexToDelete; //db.curBranch.sIndex;
          //db.xpos -= db.curBranch.sym[symIndex].width * db.curProb.gridW * db.curBranch.bScale; // check
          db.curBranch.sIndex--;
          if (db.curBranch.sym[symIndex] != null) {
            let temp = db.curBranch.sym[symIndex].width*db.curProb.gridW;    //*db.curBranch.bScale*db.curProb.gridW;
   
          db.xpos -= temp;
          }
          else {
            return;
          }
      }
      else {
             symIndex = sIndexToDelete+1; //db.curBranch.sIndex+1;
      } 
    

      if (db.curBranch.sym[symIndex].groupCode == symConst.CV_BRANCHING_GRP) {
        freeSymbolBranches(db.curBranch,symIndex);  
      } 

      if (db.curBranch.sym[symIndex].crossOff != null) {
        db.curBranch.container.removeChild(db.curBranch.sym[symIndex].crossOff);
      }
      textToDelete = db.curBranch.sym[symIndex].displayText;
      db.curBranch.container.removeChild(textToDelete);  
      let shiftSyms = db.curBranch.deleteSym(db.curBranch.sym[symIndex],symIndex);

      if (shiftSyms) { 
        resetLineTextPos(db.curBranch);
        if (db.curBranch.parent != null && db.curBranch.parent.isBranch) {
          resetLineTextPos(db.curBranch.parent);
        }
      }
      resetLineTextPos(db.curLine);

      //console.log(db.curLine);
      
          
    doStageUpdate();
    return(shiftSyms);
}   

/**
 * recursive routine!
 * function freeSymbolBranches traverses a branching symbol's branches 
 * located at symbol symIndex on branch,
 * and calls itself to find any additional branching symbols
 * It then removes from createjs the containers of these branches
 * The branching symbol delete itself is handled elsewhere
 */
function freeSymbolBranches(branch,symIndex) {

    for (let j = 1; j <= branch.sym[symIndex].branchCount; j++) {
    var nextBranch = branch.sym[symIndex].branch[j-1];
  
    // some branches may have been previously deleted by user, so skip those
    if (nextBranch != null) { 

        // call itself to find any further branches
        for (let k=0; k <= nextBranch.sym.length-1; k++) {
          if (nextBranch.sym[k].groupCode == symConst.CV_BRANCHING_GRP) {
            freeSymbolBranches(nextBranch,k);
          }
        }

        db.curLine.container.removeChild(nextBranch.container);
    }
  }

  // Remove ONLY the symbol being deleted from the line's growing-line list (branchSymList),
  // matched by object identity.  (Previously this matched on parentBranch, which removed EVERY
  // growing symbol sharing the same line/branch - so deleting one fraction/sqrt/segment stopped
  // its siblings from resizing.)  Nested growing symbols are removed by the recursion above.
  let listIndex = db.curLine.branchSymList.indexOf(branch.sym[symIndex]);
  if (listIndex >= 0) {
    db.curLine.branchSymList.splice(listIndex, 1);
  }
}


export function writeCalcBranchSym(keyID, groupCode, typeCode) {
 
  draw(symConst.KEY_ID_FRACTION, symConst.CV_BRANCHING_GRP, symConst.CV_FRACTION_TYPE);
  switch (keyID) {
    case symConst.KEY_ID_DER_1:
    case symConst.KEY_ID_DER_2:
      draw(symConst.KEY_ID_DER_D, symConst.CV_LONG_GRP, symConst.CV_DERIVATIVE_TYPE);
      cvControl(symConst.CV_CNTL_COMPLETE);
      draw(symConst.KEY_ID_DX, symConst.CV_LONG_GRP, symConst.CV_DERIVATIVE_TYPE);
      break;
    case symConst.KEY_ID_DER_3:
      draw(symConst.KEY_ID_DER_D, symConst.CV_LONG_GRP, symConst.CV_DERIVATIVE_TYPE);
      cvControl(symConst.CV_CNTL_COMPLETE);
      draw(symConst.KEY_ID_DT, symConst.CV_LONG_GRP, symConst.CV_DERIVATIVE_TYPE);
      break;
    case symConst.KEY_ID_DER_4:
      //draw(symConst.KEY_ID_DER_HALF_SPACE, symConst.CV_LONG_GRP, symConst.CV_DERIVATIVE_TYPE);
      draw(symConst.KEY_ID_DER_D_SQR, symConst.CV_LONG_GRP, symConst.CV_DERIVATIVE_TYPE);
      cvControl(symConst.CV_CNTL_COMPLETE);
      draw(symConst.KEY_ID_DER_D, symConst.CV_LONG_GRP, symConst.CV_DERIVATIVE_TYPE);
      draw(symConst.KEY_ID_X_SQR, symConst.CV_LONG_GRP, symConst.CV_VAR_SQR_TYPE);
      break;
    case symConst.KEY_ID_DER_5:
      draw(symConst.KEY_ID_DY, symConst.CV_LONG_GRP, symConst.CV_DERIVATIVE_TYPE);
      cvControl(symConst.CV_CNTL_COMPLETE);
      draw(symConst.KEY_ID_DX, symConst.CV_LONG_GRP, symConst.CV_DERIVATIVE_TYPE);
      break;
    case symConst.KEY_ID_DER_6:
      draw(symConst.KEY_ID_DER_D_SQR, symConst.CV_LONG_GRP, symConst.CV_DERIVATIVE_TYPE);
      draw(symConst.KEY_ID_Y, symConst.CV_LONG_GRP, symConst.CV_VAR_TYPE);
      cvControl(symConst.CV_CNTL_COMPLETE);
      draw(symConst.KEY_ID_DER_D, symConst.CV_LONG_GRP, symConst.CV_DERIVATIVE_TYPE);
      draw(symConst.KEY_ID_X_SQR, symConst.CV_LONG_GRP, symConst.CV_VAR_SQR_TYPE);
      break;
    case symConst.KEY_ID_DER_7:
      draw(symConst.KEY_ID_DER_D_SQR, symConst.CV_LONG_GRP, symConst.CV_DERIVATIVE_TYPE);
      draw(symConst.KEY_ID_Y, symConst.CV_LONG_GRP, symConst.CV_VAR_TYPE);
      cvControl(symConst.CV_CNTL_COMPLETE);
      draw(symConst.KEY_ID_DER_D, symConst.CV_LONG_GRP, symConst.CV_DERIVATIVE_TYPE);
      draw(symConst.KEY_ID_T_SQR, symConst.CV_LONG_GRP, symConst.CV_VAR_SQR_TYPE);
    break;
  }
  
  //
  if (keyID == symConst.KEY_ID_DER_2) {
    cvControl(symConst.CV_CNTL_ADVANCE);
  }
  else {
    cvControl(symConst.CV_CNTL_COMPLETE);
  }
  
}